module.exports = __webpack_public_path__ + "img/buyNow.3015e474.svg";